module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-12.a1f48b5c.mp3";